<div class="home-filter-shell">
  <HomeNavBar @active-profile-loaded="set_active_profile" />
  <InactivityModal />

  <div class="container-fluid bg-white pb-extra">
    <div class="row p-2 g-3">
      <div class="col-12">
        <header class="d-flex gap-2 align-items-start mb-3">
          <button
            @click="$router.push({ name: 'organisation' })"
            class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
            type="button"
          >
            <i class="bi bi-chevron-left fs-5"></i>
          </button>

          <div>
            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
              <h4 class="fw-bold mb-0">Payment Account Configuration</h4>
              <span class="task-chip task-chip-status text-capitalize">{{ has_payfast_config ? 'Configured' : 'Not Configured' }}</span>
            </div>
            <p class="mb-0">Configure the payment credentials used for organisation donations.</p>
          </div>
        </header>

        <div class="home-filter-panel">

          <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
              <div v-if="payfast_error" class="alert alert-danger text-xxs mb-3">{{ payfast_error }}</div>
              <div v-if="payfast_loading" class="text-muted text-xxs mb-3">Loading payment account settings...</div>
              <div class="alert alert-warning text-xxs py-1 px-3 mb-2">
                Please confirm the merchant ID, merchant key, and passphrase before saving this payment account.
              </div>

              <div class="row g-3" autocomplete="off">
                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    Merchant ID <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="payfast_form.merchant_id"
                    type="text"
                    class="form-control rounded text-xxs"
                    autocomplete="off"
                    placeholder="Enter merchant ID"
                  />
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-500">
                    Merchant Key <span class="text-danger">*</span>
                  </label>
                  <div class="input-group">
                    <input
                      v-model="payfast_form.merchant_key"
                      :type="show_payfast_merchant_key ? 'text' : 'password'"
                      class="form-control rounded-start text-xxs"
                      autocomplete="new-password"
                      placeholder="Enter merchant key"
                    />
                    <button
                      type="button"
                      class="btn rounded-end bg-light border"
                      @click="show_payfast_merchant_key = !show_payfast_merchant_key"
                    >
                      <i :class="show_payfast_merchant_key ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label text-xxs fw-500">Passphrase</label>
                  <div class="input-group">
                    <input
                      v-model="payfast_form.passphrase"
                      :type="show_payfast_passphrase ? 'text' : 'password'"
                      class="form-control rounded-start text-xxs"
                      autocomplete="new-password"
                      placeholder="Enter passphrase"
                    />
                    <button
                      type="button"
                      class="btn rounded-end bg-light border"
                      @click="show_payfast_passphrase = !show_payfast_passphrase"
                    >
                      <i :class="show_payfast_passphrase ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap gap-2 mt-4">
                <button
                  type="button"
                  class="btn btn-primary text-xxs rounded px-3"
                  :disabled="payfast_saving || payfast_loading"
                  @click="save_payfast_config"
                >
                  {{ payfast_saving ? 'Saving...' : (has_payfast_config ? 'Update Account' : 'Save Account') }}
                </button>

                <button
                  v-if="has_payfast_config"
                  type="button"
                  class="btn btn-danger text-xxs rounded px-3"
                  :disabled="payfast_saving"
                  @click="delete_payfast_config"
                >
                  {{ payfast_saving ? 'Removing...' : 'Delete Account' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <StickyNav activeTab="normal_loans_info" />
</div>



